<template>
  <div v-resize="onResize">
    <v-menu
      v-if="forceInMenu || (isUseMenu && !forceInList)"
      absolute
      close-on-content-click
    >
      <template v-slot:activator="{ on }">
        <base-button icon v-on="on">
          <v-icon>{{ icon }}</v-icon>
        </base-button>
      </template>
      <v-list class="py-0" dense>
        <v-list-item
          v-for="(item, index) in currentItems"
          :key="index"
          v-bind="getBind(item)"
          @click="item.handler(value)"
        >
          <v-list-item-icon class="mr-2">
            <v-icon :color="getColor(item)" small>{{ getIcon(item) }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ getTitle(item) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-else>
      <template v-for="(item, index) in currentItems">
        <base-button
          :key="index"
          v-bind="getBind(item)"
          icon
          @click.stop="item.handler(value)"
        >
          <v-icon size="20">{{ getIcon(item) }}</v-icon>
        </base-button>
      </template>
    </div>
  </div>
</template>

<script>
import { defaultTypeButon } from '@src/constant'
const sizeIcon = 30
export default {
  props: {
    /** @type {Array<{color: string | Function, title: string | Function, icon: string | Function, disabled: string | Function, type: 'add' | 'update' | 'delete'}>} */
    items: { type: Array, default: () => [], required: true },
    value: {},
    icon: { type: String, default: 'mdi-dots-horizontal' },
    forceInList: Boolean,
    forceInMenu: Boolean,
  },
  data: () => ({
    isUseMenu: true,
    currentItems: [],
    currentWidth: 0,
  }),
  mounted() {
    this.checkWidth()
  },
  computed: {},
  watch: {
    items: {
      handler(value) {
        if (value) {
          this.currentItems = value
            .map((x) => ({
              ...x,
              ...defaultTypeButon[x.type],
            }))
            .filter((x) => !x.hide || !x.hide(this.value))
        }
      },
      immediate: true,
    },
  },
  methods: {
    getBind(item) {
      let bind = {}
      bind = {
        disabled: this.getDisabled(item),
        color: this.getColor(item),
        tooltip: this.getTitle(item),
      }
      if (item.to) {
        bind.to = item.to(this.value)
      }
      return bind
    },
    getTitle(item) {
      if (typeof item.title == 'function') {
        return item.title(this.value)
      }
      return item.title
    },
    getColor(item) {
      if (typeof item.color == 'function') {
        return item.color(this.value)
      }
      return item.color
    },
    getIcon(item) {
      if (typeof item.icon == 'function') {
        return item.icon(this.value)
      }
      return item.icon
    },
    getDisabled(item) {
      if (typeof item.disabled == 'function') {
        return item.disabled(this.value)
      }
      return item.disabled
    },
    checkWidth() {
      this.currentWidth = this.$el.offsetWidth
      this.isUseMenu = this.$el.offsetWidth < this.items.length * sizeIcon
    },
    onResize(e) {
      if (e) {
        this.checkWidth()
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
